export const movementTemplatesEn = {
  title: 'List of rules for transfer tasks',
  backToList: 'Back to rules list',
  createTemplate: 'Create a rule',
  settingsTemplate: 'Customize rules',
  copyFromOtherBoard: 'Copy from another board',
  helpWithImage: 'About templates of moving with examples',
  createTitle: 'Creating a new rule',
  editTitle: (title: string) => `Edit the rule “${title}”`,
  createTitlePlaceholder: 'Enter the rule name',
  createMoveTo: 'Destination:',
  createAvailableFrom: 'Move available from columns:',
  createActionsAfter: 'Actions after moving:',
  createRemoveAssigned: 'Delete assigned',
  optionAllCurrent: 'All current',
  optionAllCurrentExceptYourself: 'All current, except yourself',
  optionSpecificUsers: 'Specific users...',
  createAddNewAssigned: 'Add new assigned',
  createUnsubscribeFromChat: 'Unsubscribe from the task chat',
  createSubscribeFromChat: 'Subscribe on the task chat',
  createUnpinStickers: 'Unpin stickers',
  createPinStickers: 'Pin stickers (and stickers states)',
  destinationNotSelected: 'Not selected',
  destinationProjectPlaceholder: 'Project',
  destinationBoardPlaceholder: 'Board',
  destinationColumnPlaceholder: 'Column',
  columnsAllCaption: 'Columns',
  stickersAllCaption: 'Stickers',
  destinationSelectColumnPlaceholder: 'Select column',
  destinationSelectColumnsPlaceholder: 'Select columns',
  destinationSelectStickersPlaceholder: 'Select stickers',
  messageDeleteConfirm: 'Delete the task transfer rule?',
  createButton: 'Create Rule',
  saveButton: 'Save the rule',
  placeholderAssigned: 'Select assigned',
  placeholderUsers: 'Select users',
  moveHint: `Move:`,
  moveHintValue: (value: string) => `"${value}"`,
  noAccess: 'No access',
  noAccessFull: 'You do not have access to the wrong destination',
  noAccessFull2: 'No rights to view object',
  allProjects: 'All projects',
  allBoards: 'All boards',
  allColumns: 'All columns'
}

export const movementTemplatesRu: typeof movementTemplatesEn = {
  title: 'Список правил для передачи задач',
  backToList: 'Назад к списку правил',
  createTemplate: 'Создать правило',
  settingsTemplate: 'Настроить правила',
  copyFromOtherBoard: 'Скопировать из другой доски',
  helpWithImage: 'Подробнее о функции с примерами',
  createTitle: 'Создание нового правила',
  editTitle: (title: string) => `Редактирование правила “${title}”`,
  createTitlePlaceholder: 'Введите название правила',
  createMoveTo: 'Место назначения:',
  createAvailableFrom: 'Перемещение доступно из колонок:',
  createActionsAfter: 'Действия после перемещения:',
  createRemoveAssigned: 'Удалить исполнителей',
  optionAllCurrent: 'Всех текущих',
  optionAllCurrentExceptYourself: 'Всех текущих, кроме себя',
  optionSpecificUsers: 'Конкретных пользователей...',
  createAddNewAssigned: 'Добавить новых исполнителей',
  createUnsubscribeFromChat: 'Отписать от чата задачи',
  createSubscribeFromChat: 'Подписать на чат задачи',
  createUnpinStickers: 'Открепить стикеры',
  createPinStickers: 'Прикрепить стикеры (и состояния стикеров)',
  destinationNotSelected: 'Не выбрано',
  destinationProjectPlaceholder: 'Проект',
  destinationBoardPlaceholder: 'Доска',
  destinationColumnPlaceholder: 'Колонка',
  columnsAllCaption: 'Колонки',
  stickersAllCaption: 'Стикеры',
  destinationSelectColumnPlaceholder: 'Выберите колонку',
  destinationSelectColumnsPlaceholder: 'Выберите колонки',
  destinationSelectStickersPlaceholder: 'Выберите стикеры',
  messageDeleteConfirm: 'Удалить правило передачи задач?',
  createButton: 'Создать правило',
  saveButton: 'Сохранить правило',
  placeholderAssigned: 'Выберите исполнителей',
  placeholderUsers: 'Выберите пользователей',
  moveHint: `Переместить:`,
  moveHintValue: (value: string) => `"${value}"`,
  noAccess: 'Нет доступа',
  noAccessFull: 'У Вас нет доступа к месту назначения',
  noAccessFull2: 'Нет прав для просмотра объекта',
  allProjects: 'Все проекты',
  allBoards: 'Все доски',
  allColumns: 'Все колонки'
}
